import React, { Fragment, FunctionComponent, ReactChild, ReactElement, ReactNode} from 'react'

//Custom Components
import useFormController from "@/components/useFormController";
import FormContent from "@/components/FormContent";

//Types
import { FormControllerProps } from "@/@types/components/formController";

const Form: FunctionComponent<React.PropsWithChildren<FormControllerProps>> =(props) => {
  const { children } = props;
  const { record, validation, fields, onFieldChange } = useFormController(props);

  const handleFieldChange = (value: any, source: string) => {

    if (onFieldChange) {
      onFieldChange(value, source);
    }
  }

  const buildFormContent = (child: ReactElement, i: number) => {
    return (
      <FormContent
        key={i}
        record={record}
        validation={validation}
        fields={fields}
        onFieldChange={handleFieldChange}
        {...child.props}
      />
    );
  }


  let formElements = [];
  if (Array.isArray(children)) {
    React.Children.forEach(children, (child, i) => {
      if (child !== null) {
        if ((child as ReactElement).type === FormContent) {
          formElements.push(buildFormContent(child as ReactElement, i));
        } else {
          formElements.push(child);
        }
      }
    })
  } else {
    if (children !== null) {
      const child = children;
      if (child !== null) {
        if ((child as ReactElement).type === FormContent) {
          formElements.push(buildFormContent(child as ReactElement, 1));
        } else {
          formElements.push(child);
        }
      }
    }
  }

  return (
    <Fragment>
      {formElements}
    </Fragment>
  );
}

export default Form;